import { MessageBar, MessageBarBody, __css, tokens } from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';
import { useLocale } from '@/app/providers/i18n-provider';
import { EXPIRY_WARNING_DAYS, dateText, daysUntil } from './model';

const useStyles = __css({"bar":{"Beyfa6y":0,"Bbmb7ep":0,"Btl43ni":0,"B7oj6ja":0,"Dimara":"fokr779","Bnt446c":0,"B1hrpyx":0,"Fjva8n":"fjshy37"}});

/**
 * "Votre accès invité se termine le …": shown to a guest on every page of an invited space. In the
 * last 14 days it takes the warning style and says what to do (the words carry the urgency, the
 * colour only helps).
 */
export function GuestExpiryNotice({ expiresAt }: { expiresAt: string }) {
  const { t } = useTranslation('spaces');
  const styles = useStyles();
  const locale = useLocale();
  const soon = daysUntil(expiresAt, new Date()) <= EXPIRY_WARNING_DAYS;
  return (
    <MessageBar className={styles.bar} intent={soon ? 'warning' : 'info'} layout="multiline">
      <MessageBarBody>
        {t('guest.expiry', { date: dateText(expiresAt, locale) })}
        {soon ? ` ${t('guest.expirySoon')}` : ''}
      </MessageBarBody>
    </MessageBar>
  );
}


import "/opt/batiflow/app/apps/web/src/features/spaces/sharing/guest-expiry-notice.griffel.css";